import React, { Dispatch, SetStateAction, useState } from 'react';
import FormLabel from 'components/form-label';
import { Input } from 'components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import FormInput from 'components/form/input';

interface IProps {
  deviceConfig: Record<string, string | undefined | null>;
  disabled?: boolean;
  inModal?: boolean;
  setDeviceConfig?: Dispatch<SetStateAction<Record<string, string | undefined | null>>>;
  register?: UseFormRegister<FieldValues>;
  setValue?: UseFormSetValue<FieldValues>;
}

export const CUSTOM_RECIEPT_OPTIONS = [
  {
    name: 'Customer Payment Receipt',
    value: 'CUSTOMER',
  },
  {
    name: 'Merchant Payment Receipt',
    value: 'MERCHANT',
  },
  {
    name: 'Both Payment Receipts',
    value: 'BOTH',
  },
  {
    name: 'Only Treez Receipt',
    value: 'TREEZ',
  },
  {
    name: 'None',
    value: 'NONE',
  },
];
const FullDeviceConfig = ({
  deviceConfig,
  disabled = true,
  inModal = true,
  setDeviceConfig,
  register,
  setValue,
}: IProps) => {
  const [printOptionSetting, setPrintOptionSetting] = useState(
    deviceConfig.printConfig ? 'Custom' : 'Default'
  );
  const [authCodeSetting, setAuthCodeSetting] = useState(
    deviceConfig?.deviceAuthCode ? 'Custom' : 'Default'
  );

  return (
    <>
      <div className={!inModal ? 'ml-4 pt-2' : ''}>
        <div className="mb-3">
          <FormLabel
            element="register_id"
            label="Register Id"
            className="text-sm font-medium text-gray-blue-80 mb-1"
          />
          <Input
            name="register_id"
            id="register_id"
            className={inModal ? 'w-full mt-1 bg-gray-blue-1' : 'w-80 mt-1 bg-gray-blue-1'}
            disabled={disabled}
            defaultValue={deviceConfig.registerId || ''}
            onChange={(e) => {
              if (inModal && setDeviceConfig) {
                const { value } = e.currentTarget;
                setDeviceConfig((prev) => ({ ...prev, registerId: value }));
              }
            }}
          />
        </div>
        <div className="mb-3">
          <FormLabel
            element="tpn"
            label="Device TPN"
            className="text-sm font-medium text-gray-blue-80 mb-1"
          />
          <Input
            name="tpn"
            id="tpn"
            className={inModal ? 'w-full mt-1 bg-gray-blue-1' : 'w-80 mt-1 bg-gray-blue-1'}
            disabled={disabled}
            defaultValue={deviceConfig.tpn || ''}
            onChange={(e) => {
              if (inModal && setDeviceConfig) {
                const { value } = e.currentTarget;
                setDeviceConfig((prev) => ({ ...prev, tpn: value }));
              }
            }}
          />
        </div>
        <div className="flex gap-4">
          <div className="mb-3 flex-1">
            <FormLabel
              element="type_printing_option"
              label="Payment Receipt Printing Option"
              className="text-sm font-medium text-gray-blue-80 mb-1"
            />
            <Select
              value={printOptionSetting}
              onValueChange={(value) => {
                if (setDeviceConfig && value === 'Default') {
                  setDeviceConfig((prev) => ({ ...prev, printConfig: 'NONE' }));
                }
                setPrintOptionSetting(value);
              }}
              disabled={disabled}
            >
              <SelectTrigger
                id="type_printing_option"
                className="mt-1 bg-gray-blue-1 w-full"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Default">Default</SelectItem>
                <SelectItem value="Custom">Custom</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="mb-3 flex-1">
            <FormLabel
              element="printing_option"
              label="&nbsp;"
              className="text-sm font-medium text-gray-blue-80 mb-1 block"
            />
            <Select
              value={deviceConfig?.printConfig || 'NONE'}
              onValueChange={(value) => {
                if (inModal && setDeviceConfig) {
                  setDeviceConfig((prev) => ({ ...prev, printConfig: value }));
                }
              }}
              disabled={disabled || printOptionSetting === 'Default'}
            >
              <SelectTrigger
                id="printing_option"
                className="mt-1 bg-gray-blue-1 w-full"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {CUSTOM_RECIEPT_OPTIONS.map((item) => (
                  <SelectItem key={item.value} value={item.value}>
                    {item.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="flex gap-4">
          <div className="mb-3 flex-1">
            <FormLabel
              element="auth_code_type"
              label="Auth Code"
              className="text-sm font-medium text-gray-blue-80 mb-1"
            />
            <Select
              value={authCodeSetting}
              onValueChange={(value) => {
                if (setDeviceConfig && value === 'Default') {
                  setValue?.('authCode', '');
                  setDeviceConfig((prev) => ({ ...prev, deviceAuthCode: '' }));
                }
                setAuthCodeSetting(value);
              }}
              disabled={disabled}
            >
              <SelectTrigger
                id="auth_code_type"
                className="mt-1 bg-gray-blue-1 w-full"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Default">Default</SelectItem>
                <SelectItem value="Custom">Custom</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="mb-3 flex-1">
            <FormLabel
              element="authCode"
              label="&nbsp;"
              className="text-sm font-medium text-gray-blue-80 mb-1 block"
            />
            <FormInput
              type="password"
              name="authCode"
              id="authCode"
              className="w-full mt-1 bg-gray-blue-1"
              register={register}
              disabled={disabled || authCodeSetting === 'Default'}
              defaultValue={
                deviceConfig?.deviceAuthCode
                  ? `%${deviceConfig.registerId}%`
                  : ''
              }
              onChange={(e) => {
                if (inModal && setDeviceConfig) {
                  const { value } = e.currentTarget;
                  setDeviceConfig((prev) => ({ ...prev, deviceAuthCode: value }));
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FullDeviceConfig;
